import React from 'react';
import moment from 'moment';
import { FORMAT_NUMBER } from '../libs/utils/Const';

const renderTableBody = (headers, data, checkbox, openDetails) => {
    const body = data.map((document, index) => {
        return (
            <tr key={index} className="text-center align-middle">
                <td>{index + 1}</td>
                <td>{document?.Code ?? '--'}</td>
                <td>{document?.U_FMB_WhsCode ?? '--'}</td>
                <td>{document?.LastRead ?? '--'}</td>
                <td>{document?.ReadingDate ? moment(document.ReadingDate).format('DD-MM-YYYY') : '--'}</td>
                <td class="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                    <button type="button" className="btn btn-timbra-one btksn-sm botonCorrect"
                        onClick={() => openDetails(document)} style={{ fontWeight: '500' }}>
                        <i class="far fa-file-alt"> </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )

    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header =
            <tr className="text-center align-middle">
                <td>#</td>
                {headers[0].value && <td>{headers[0].title}</td>}
                {headers[1].value && <td>{headers[1].title}</td>}
                {headers[2].value && <td>{headers[2].title}</td>}
                {headers[3].value && <td>{headers[3].title}</td>}
                <td class="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

            </tr>;
    }
    body = renderTableBody(headers, data, checkbox, openDetails);
    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;
}

export const renderCanalizadoTanque = (headers, data, checkbox, openDetails) => {
    return renderTable(headers, data, checkbox, openDetails);

}   